var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertaiIconFullWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "95.91 457.14 889.12 165.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 199.79,
    cy: 519.14,
    r: 22.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.79,586.13c-36.94,0-66.99-30.05-66.99-66.99,0-25.29,14.08-47.34,34.82-58.74-35.35-4.62-68.06,2.02-68.06,2.02,0,0-17.87,88.06,25.43,131.35,43.29,43.29,131.35,25.43,131.35,25.43,0,0,6.58-32.47,2.07-67.66-11.44,20.61-33.42,34.6-58.61,34.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.79,554c19.22,0,34.86-15.64,34.86-34.86s-15.64-34.86-34.86-34.86-34.86,15.64-34.86,34.86,15.64,34.86,34.86,34.86ZM199.79,496.82c12.33,0,22.32,9.99,22.32,22.32s-9.99,22.32-22.32,22.32-22.32-9.99-22.32-22.32,9.99-22.32,22.32-22.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.79,457.15c-8.3,0-16.22,1.65-23.46,4.62-22.58,9.27-38.53,31.49-38.53,57.37,0,34.18,27.81,61.99,61.99,61.99,25.79,0,47.94-15.83,57.27-38.29,3.04-7.31,4.72-15.31,4.72-23.71,0-34.18-27.81-61.99-61.99-61.99ZM199.79,559c-21.98,0-39.86-17.88-39.86-39.86s17.88-39.86,39.86-39.86,39.86,17.88,39.86,39.86-17.88,39.86-39.86,39.86Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M444.77,561.54v51.86h-25.1v-10.04c-5.02,6.48-15.68,11.92-30.95,11.92-30.32,0-52.07-21.75-52.07-54.16s21.75-53.75,53.95-53.75,54.16,21.75,54.16,54.16ZM390.81,530.38c-17.57,0-29.07,11.5-29.07,30.95s11.5,30.95,29.07,30.95,28.86-11.5,28.86-30.95-11.5-30.95-28.86-30.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M467.43,467.01h25.1v146.39h-25.1v-146.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M589.06,580.99h27.4c-6.9,21.12-25.51,34.3-50.82,34.3-32.41,0-54.16-21.75-54.16-54.16s21.75-53.75,54.16-53.75,53.95,21.54,53.95,53.75c0,2.93-.21,5.65-.42,8.37h-81.77c2.72,14.43,13.18,22.79,28.02,22.79,10.46,0,18.61-3.97,23.63-11.29ZM591.78,546.48c-4.39-10.25-13.8-16.1-26.35-16.1s-21.75,5.86-26.14,16.1h52.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M689.17,506.96v23c-16.73,0-26.77,8.16-26.77,24.89v58.56h-25.1v-58.56c0-31.79,20.08-47.89,51.86-47.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M757.32,614.87c-34.3,0-52.49-17.36-52.49-49.56v-98.29h25.1v41.83h23.84v23h-23.84v33.25c0,19.03,7.74,26.77,27.4,26.77v23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M936.75,561.54v51.86h-25.1v-10.04c-5.02,6.48-15.68,11.92-30.95,11.92-30.32,0-52.07-21.75-52.07-54.16s21.75-53.75,53.95-53.75,54.16,21.75,54.16,54.16ZM882.79,530.38c-17.57,0-29.07,11.5-29.07,30.95s11.5,30.95,29.07,30.95,28.86-11.5,28.86-30.95-11.5-30.95-28.86-30.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M971.23,464.71c7.74,0,13.8,6.27,13.8,13.8,0,7.95-6.06,14.01-13.8,14.01s-13.8-6.06-13.8-14.01c0-7.53,6.06-13.8,13.8-13.8ZM958.68,508.84h25.1v104.56h-25.1v-104.56Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertaiIconFullWhite);
export default __webpack_public_path__ + "static/media/alertai_icon_full_white.0e29a2dcc01f1cc646dad43b79788f45.svg";
export { ForwardRef as ReactComponent };